<div class="changelog-item">
  <div class="item__image-wrapper">
    <img class="profile-image-container__avatar" src="{{ author.profileImage }}" alt="Author Image">
  </div>
  <div class="changelog__right">
    <div class="changelog-item__name">
      {{ author.name | titlecase }}
      <!-- the date property is not present with the data in the database: 8/13/2024 -->
      <!-- <div class="changelog-item__date"> -->
        <!-- on {{ changelog.date | date:'shortDate' }} -->
      <!-- </div> -->
    </div>
    <div class="changelog-item__text" [innerHtml]="changelog.text"></div>
  </div>
  <div class="changelog-item__timeline"></div>
</div>